<template>
  <page />
  <es-dialog id="es-dialog" />
  <es-dialog id="es-dialog-conceal-login">
    <view slot="content">
      <view class="protocol text">我阅读并同意以下协议</view>
      <view class="protocol url" bindtap="goto">《账户授权协议》</view>
      <view class="protocol text">同意受本协议约束</view>
    </view>
  </es-dialog>
  <es-dialog id="es-dialog-book">
    <view class="bottom-conceal-text" slot="content">
      我阅读并同意以下协议
      <view
        class="protocol url"
        wx:for="{{purchaseList}}"
        wx:key="index"
        bindtap="jumpToLicense(item, index)"
      >
        《{{ item.name }}》
      </view>
    </view>
  </es-dialog>
</template>

<style lang="stylus" scoped>
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color #666
    &.url
      color #338FFF
</style>

<script>
  import { createPage } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import store from '@/store'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'

  createPage({
    data() {
      return {
      }
    },
    computed: {
      ...store.mapState({
        reminders: 'makeOrder.makeOrderBaseInfo.reminders'
      }),
      purchaseList() {
        if (this.reminders == null) {
          return []
        }
        return (this.reminders?.purchase_note || []).concat(this.reminders?.privacy_protocol || [])
      }
    },
    methods: {
      async goto() {
        let goToUrl =
          'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?s=op-json-YTlYhv459#/xpub'
        innerRouter.goTo(goToUrl)
      },
      jumpToLicense(item, index) {
        Dialog.close()
        if (item.name === '铁路互联网购票须知') {
          innerRouter.push(pagePath().ICKETPURCHASENOTICE)
        } else {
          innerRouter.goTo(item.url)
        }
      }
    }
  })
</script>

<script name="json">
  module.exports = {
    usingComponents: {
      page: './index'
    }
  }
</script>
